/**
 * A function that limits the amount that a function can be executed
 * within a certain amount of time
 * This is useful for events like scroll and resize that don't need to be called
 * back to back
 *
 * Example
 * function handleScroll(el) {
 *   const { scrollHeight } = el
 *   if (scrollHeight) > 50 {...}
 * }
 * 
 * // Ensure the function only executes once in 500ms
 * const throttledHandler = throttle(handleScroll, 500)
 * window.addEventListener('scroll', throttledHandler)
 */

export default function throttle(fn, threshold = 250, scope) {
	let last, deferTimer
	return function (...args) {
		const context = scope || this
		const now = +new Date
		if (last && now < last + threshold) {
			clearTimeout(deferTimer)
			deferTimer = setTimeout(() => {
				last = fn
				fn.apply(context, args)
			}, threshold)
		} else {
			last = now
			fn.apply(context, args)
		}
	}
}
